module.exports = __webpack_public_path__ + "img/corners.8975d8a.png";